import { StyledEngineProvider } from "@mui/material/styles";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./i18n";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Failed to load");
}

const loadMSW = async () => {
  if (process.env.NODE_ENV === "development") {
    const { worker } = await import("./mocks/browser");
    worker.start();
  }
};

loadMSW().then(() => {
  root.style.minHeight = "100vh";
  createRoot(root).render(
    <React.StrictMode>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </React.StrictMode>,
  );
});
